import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import VisionMission from "./components/VisionMission";
import Projects from "./components/Projects";
import Awards from "./components/Awards";
import Team from "./components/Team";
import Gallery from "./components/Gallery";
import Video from "./components/Video";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProjectDetail from "./components/ProjectDetail";
import "./App.css";

function Home() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <VisionMission />
      <Projects />
      <Awards />
      <Team />
      <Gallery />
      <Video />
      <Contact />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
